import { CookieCategoryInfo } from '@/types/consent';

export const COOKIE_CATEGORIES: CookieCategoryInfo[] = [
  {
    id: 'necessary',
    name: 'Strictly Necessary',
    description:
      'These technologies provide authentication, security, routing and consent records. They cannot be disabled.',
    required: true,
    cookies: [
      {
        name: 'Keycloak session cookies',
        provider: 'WIANCO Portal',
        purpose: 'Authenticates your Portal account and maintains single sign-on.',
        expiry: 'Session or configured login lifetime',
        type: 'cookie',
      },
      {
        name: 'community_session, academy_session, support_session, launchpad_session',
        provider: 'WIANCO Portal',
        purpose: 'Maintains authenticated sessions in the embedded Portal services.',
        expiry: 'Up to 8 hours',
        type: 'cookie',
      },
      {
        name: 'csrf_token',
        provider: 'WIANCO Portal',
        purpose: 'Protects forms and state-changing requests against cross-site request forgery.',
        expiry: 'Session',
        type: 'cookie',
      },
      {
        name: 'shell-consent-preferences',
        provider: 'WIANCO Portal',
        purpose: 'Records your privacy and storage preferences, their date and policy version.',
        expiry: 'Until deleted or the policy version changes',
        type: 'localStorage',
      },
      {
        name: 'SHELL_AUTH_SESSION',
        provider: 'WIANCO Portal',
        purpose: 'Temporarily maintains the active Portal authentication token.',
        expiry: 'Browser tab session',
        type: 'sessionStorage',
      },
      {
        name: 'shell-login-return-path, shell-runtime-version-refresh',
        provider: 'WIANCO Portal',
        purpose:
          'Returns you to the requested page after login and prevents repeated version reloads.',
        expiry: 'Browser tab session',
        type: 'sessionStorage',
      },
    ],
  },
  {
    id: 'functional',
    name: 'Functional',
    description:
      'These local settings remember interface choices you make. The Portal remains usable without optional preferences.',
    required: false,
    cookies: [
      {
        name: 'shell-theme, theme, *-theme',
        provider: 'WIANCO Portal',
        purpose: 'Stores your selected light or dark theme in the Portal and embedded services.',
        expiry: 'Until deleted',
        type: 'localStorage',
      },
      {
        name: 'shell-language',
        provider: 'WIANCO Portal',
        purpose: 'Stores your selected interface language.',
        expiry: '1 year',
        type: 'cookie',
      },
      {
        name: 'community-language, academy-language, support-language, shop-language',
        provider: 'WIANCO Portal',
        purpose: 'Stores your selected interface language.',
        expiry: 'Until deleted',
        type: 'localStorage',
      },
      {
        name: 'portal.mobileOverviewButtonPosition',
        provider: 'WIANCO Portal',
        purpose: 'Stores the position selected for the mobile overview control.',
        expiry: 'Until deleted',
        type: 'localStorage',
      },
      {
        name: 'shell-not-found-best-score',
        provider: 'WIANCO Portal',
        purpose: 'Stores the local high score of the optional offline error-page game.',
        expiry: 'Until deleted',
        type: 'localStorage',
      },
    ],
  },
];
